import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import NotificationBell from '../notifications/NotificationBell';
import '../styles/header.css';

const Header = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const getDashboardPath = () => {
    if (user?.role === 'astrologer') return '/astrologer/dashboard';
    if (user?.role === 'admin') return '/admin/invitations';
    return '/dashboard';
  };

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  const handleNav = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  // Close menu on resize to desktop
  useEffect(() => {
    const handleResize = () => { if (window.innerWidth > 768) setMenuOpen(false); };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className="main-header">
      <div className="logo-container">
        <img src="/images/JyotishSastra_Icon.svg" alt="JyotishSastra" className="logo" />
        <div>
          <button className="brand-button" onClick={() => handleNav('/')}>
            JyotishSastra
          </button>
          <div className="brand-tagline">Vedic Astrology Platform</div>
        </div>
      </div>

      {/* Desktop controls */}
      <div className="header-controls header-desktop">
        <select className="language-selector">
          <option value="en">English</option>
          <option value="hi">Hindi</option>
          <option value="ta">Tamil</option>
        </select>
        {isAuthenticated ? (
          <>
            <NotificationBell />
            <a href={getDashboardPath()} className="login-button" onClick={(e) => { e.preventDefault(); navigate(getDashboardPath()); }}>
              Dashboard
            </a>
            <button className="login-button logout-button" onClick={handleLogout}>
              Logout
            </button>
          </>
        ) : (
          <a href="/login" className="login-button" onClick={(e) => { e.preventDefault(); navigate('/login'); }}>
            Login
          </a>
        )}
      </div>

      {/* Mobile hamburger */}
      <div className="header-mobile" ref={menuRef}>
        {isAuthenticated && <NotificationBell />}
        <button
          className={`hamburger-btn ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span className="hamburger-line" />
          <span className="hamburger-line" />
          <span className="hamburger-line" />
        </button>

        {menuOpen && (
          <div className="mobile-menu">
            <select className="language-selector mobile-lang" defaultValue="en">
              <option value="en">English</option>
              <option value="hi">Hindi</option>
              <option value="ta">Tamil</option>
            </select>
            <button className="mobile-menu-item" onClick={() => handleNav('/')}>Home</button>
            <button className="mobile-menu-item" onClick={() => handleNav('/talk-to-astrologer')}>Talk to Astrologer</button>
            <button className="mobile-menu-item" onClick={() => handleNav('/vedic-tools')}>Vedic Tools</button>
            <button className="mobile-menu-item" onClick={() => handleNav('/consultation')}>Book Consultation</button>
            {isAuthenticated ? (
              <>
                <button className="mobile-menu-item" onClick={() => handleNav(getDashboardPath())}>Dashboard</button>
                <button className="mobile-menu-item" onClick={() => handleNav('/wallet')}>Wallet</button>
                <button className="mobile-menu-item mobile-logout" onClick={handleLogout}>Logout</button>
              </>
            ) : (
              <button className="mobile-menu-item mobile-login" onClick={() => handleNav('/login')}>Login</button>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
